import React from 'react'
import { PositionSectionProps } from './types'
import {
  PropertySection,
  SectionHeader,
  SectionTitle,
  CollapseIcon,
  SectionContent,
  Label,
  Input,
  FlexRow,
} from '../styled'

const PositionSection: React.FC<PositionSectionProps> = ({
  selectedElement,
  isCollapsed,
  onToggleSection,
  updatePosition,
}) => {
  return (
    <PropertySection>
      <SectionHeader isCollapsed={isCollapsed} onClick={onToggleSection}>
        <SectionTitle>Position</SectionTitle>
        <CollapseIcon isCollapsed={isCollapsed}>▼</CollapseIcon>
      </SectionHeader>
      <SectionContent isCollapsed={isCollapsed}>
        <FlexRow>
          <div style={{ flex: 1 }}>
            <Label>X</Label>
            <Input
              type="number"
              value={Math.round(selectedElement.position.x)}
              onChange={e => updatePosition(Number(e.target.value), undefined)}
            />
          </div>
          <div style={{ flex: 1 }}>
            <Label>Y</Label>
            <Input
              type="number"
              value={Math.round(selectedElement.position.y)}
              onChange={e => updatePosition(undefined, Number(e.target.value))}
            />
          </div>
        </FlexRow>
      </SectionContent>
    </PropertySection>
  )
}

export { PositionSection }
